import { render, staticRenderFns } from "./TjPlug.vue?vue&type=template&id=dad4ec46&scoped=true&"
import script from "./TjPlug.vue?vue&type=script&lang=js&"
export * from "./TjPlug.vue?vue&type=script&lang=js&"
import style0 from "./TjPlug.vue?vue&type=style&index=0&id=dad4ec46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad4ec46",
  null
  
)

component.options.__file = "TjPlug.vue"
export default component.exports